import React from 'react';
import { Link } from 'react-router-dom';
import { SeeIt } from '../components/SeeIt';
import { Faq } from '../components/Faq';
import { CtaBand } from '../components/CtaBand';
import { Ledger } from '../components/Ledger';
import { ChunkVsAtom } from '../components/how/ChunkVsAtom';
import { ConstitutionalFlow } from '../components/how/ConstitutionalFlow';
import { ReceiptCard } from '../components/how/ReceiptCard';
import { AgentChain } from '../components/how/AgentChain';
import { faqsHow } from '../data/faqsHow';
const ENGINES = [{
  stage: 'Harvest',
  n: '01 · Atomizer',
  title: 'Atomizer.',
  body: <>
        The written rules — FDA, HIPAA, FINRA, your brand book — and the moments nobody writes down become binary
        DO/DON'T atoms: owned, versioned, ready to fire.
      </>
}, {
  stage: 'Seat',
  n: '02 · Composer',
  title: 'Composer.',
  body: <>
        Fire the musts by trigger — off the top of the budget. Then hand retrieval a governed vocabulary, so RAG
        searches for what the rules mean, not what the prompt resembles.
      </>
}, {
  stage: 'Ship',
  n: '03 · Compiler',
  title: 'Compiler.',
  body: <>
        Assemble the payload in the model's own language, and sign the receipt: which obligations fired, which
        versions, on what trigger.
      </>
}];
export function How() {
  return <>
      <header className="hero" data-id="element-464" data-mp="2p81ufajjmqex">
        <div className="hgrid wide-r" data-id="element-465" data-mp="2p9371jg7jkyr">
          <div className="col-l" data-id="element-466" data-mp="2u63dvwkvsrqx">
            <div className="lab-row" data-id="element-467" data-mp="2u5ah9ofmzimi">
              <span className="clabel" data-id="element-468" data-mp="2fgxg8d1oz9l5">How it works</span>
            </div>
            <div className="head-block" data-id="element-469" data-mp="2feuu443nu0lp">
              <h1 style={{
              fontSize: 'clamp(28px,3.3vw,40px)',
              maxWidth: 'none'
            }} data-id="element-470" data-mp="2kfifoa94dp8j">
                From a simple request
                <br data-id="element-471" data-mp="384talb3sgper" />
                to the instructions
                <br data-id="element-472" data-mp="3cwbeo813z63y" />
                it requires.
              </h1>
            </div>
            <div className="sub-block" data-id="element-473" data-mp="3cy60rpo4949m">
              <p className="sub" style={{
              marginBottom: 16
            }} data-id="element-474" data-mp="3msjtc4p7mvdy">
                An employee asks a question. Synthia identifies the obligations behind it and selects the relevant
                instructions from your library &mdash; drawing on company expertise, regulatory requirements, and
                industry guidance.
              </p>
              <p className="sub" data-id="element-475" data-mp="38umvz62xmky8">
                Binding requirements go first, ahead of supporting information. The model receives a prepared request.
                A receipt records which instructions and versions were included.
              </p>
              <div className="ctas" data-id="element-476" data-mp="2u2uwm3jj9hi5">
                <a className="btn g" href="#process" data-id="element-477" data-mp="2u3w4y095zpw6">
                  See the process &darr;
                </a>
                <Link className="btn o" to="/contact" data-id="element-478" data-mp="2q07wlfcpkq9v">
                  Bring your highest standards &rarr;
                </Link>
              </div>
            </div>
          </div>
          <div className="col-r" data-id="element-479" data-mp="2g4mznvmhyg6z">
            <SeeIt showLink={false} variant="finance" data-id="element-480" data-mp="vm2rahns6n0n" />
          </div>
        </div>
      </header>

      <div className="quoteband" data-id="element-481" data-mp="10kng7kxl1k9s">
        <p data-id="element-482" data-mp="10jufp1p7vr03">
          Everything that carries judgment goes in.
          <br data-id="element-483" data-mp="15k9vs10vvclr" />
          <span className="q" data-id="element-484" data-mp="15jqn7ax4i0ke">Instruction data</span> comes out.
        </p>
      </div>

      <div className="stoprow" id="process" style={{
      display: 'block'
    }} data-id="element-485" data-mp="19lbzau1u2atj">
        <span className="clabel" style={{
        display: 'inline-flex',
        marginBottom: 18
      }} data-id="element-486" data-mp="19j96y3d7k5ln">
          The engines
        </span>
        <h2 style={{
        maxWidth: '36ch'
      }} data-id="element-487" data-mp="htwbwxsgck29">
          Harvest the rules. Seat the musts.
          <br data-id="element-488" data-mp="lw10hi41mqi1" />
          <span className="g" data-id="element-489" data-mp="lvhjc3m7w652">Ship the receipt.</span>
        </h2>
      </div>

      <div className="grid3" data-id="element-490" data-mp="qmpv36b0s3le">
        {ENGINES.map(e => <div className="cell" key={e.n} data-id="element-491" data-mp="qoarl1gw9wlw">
            <div className="lab" data-id="element-492" data-mp="3qahbjnz720sp">
              <span data-id="element-493" data-mp="3q9g19lq05ic1">{e.stage}</span>
              <span className="n" data-id="element-494" data-mp="3q84xhlwk4akx">{e.n}</span>
            </div>
            <h3 data-id="element-495" data-mp="3uai38abb08hp">{e.title}</h3>
            <p data-id="element-496" data-mp="3u9q6ux9vu6qd">{e.body}</p>
          </div>)}
      </div>

      <div className="split" data-id="element-497" data-mp="3b896i8cgfboe">
        <div className="sp-l" data-id="element-498" data-mp="3b7hef7i2fw2v">
          <span className="clabel" data-id="element-499" data-mp="368d247zuhi8b">Instruction data</span>
          <h2 data-id="element-500" data-mp="369xxfztzh578">
            Knowledge describes. <span className="g" data-id="element-501" data-mp="3kx0xad5s3pxq">Instructions bind.</span>
          </h2>
          <p className="lede" data-id="element-502" data-mp="3kz3ubh5cmjby">
            Your stack has a shelf for every kind of knowledge — warehouses, lakes, vector stores. It has no shelf for
            the rules. So they get pasted into prompts and retrieved only when they happen to{' '}
            <strong data-id="element-503" data-mp="3oze0att559qt">resemble the question</strong>.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-504" data-mp="3p0yrqak5sckg">
            A rule doesn't get retrieved because it's binding. It gets retrieved because it sounds like the query.{' '}
            <strong data-id="element-505" data-mp="2s5wvx1s7cxf">Facts get picked; rules get triggered</strong> — and that needs its own asset class: binary
            DO/DON'T atoms with an owner, a version, and a trigger.
          </p>
          <p className="kicker" data-id="element-506" data-mp="24kc49avodo5t">
            Resemblance is a probability.
            <br data-id="element-507" data-mp="k1rrlkpxf8to" />
            An obligation is not.
          </p>
        </div>
        <div className="sp-r" data-id="element-508" data-mp="p0bcdhssaekg">
          <ChunkVsAtom data-id="element-509" data-mp="oyi8ubdgwago" />
        </div>
      </div>

      <div className="split" data-id="element-510" data-mp="aax7alw8qjav">
        <div className="sp-l" data-id="element-511" data-mp="a9vsc6c3tcnv">
          <span className="clabel" data-id="element-512" data-mp="aandsobzlu0f">The constitutional tier</span>
          <h2 style={{
          maxWidth: 'none',
          fontSize: 'clamp(24px,2.7vw,34px)'
        }} data-id="element-513" data-mp="f8ym2ummvwgj">
            A prompt doesn&rsquo;t get
            <br data-id="element-514" data-mp="18nufpdi2dub" />
            <span className="g" data-id="element-515" data-mp="1cbp4ruol6am">to waive your obligations.</span>
          </h2>
          <p className="lede" data-id="element-516" data-mp="5ddqpfc2lufr">
            Whether a request comes from an employee or an agent, some obligations apply regardless of what it asks.
            Task instructions match the work. Standing guidance carries your organization&rsquo;s voice and
            preferences. Constitutional instructions carry the privacy, regulatory, and safety requirements bound to
            your deployment. They must be included on every pass &mdash; even when a request asks to ignore them.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-517" data-mp="1p9kwvrmdwmkt">
            Synthia checks their presence before each model call. A signed receipt records the instructions and
            versions included. Detected attempts to override them are logged for review.
          </p>
          <p className="kicker" data-id="element-518" data-mp="1abirrczpft1g">
            If the required instructions can&rsquo;t be included,
            <br data-id="element-519" data-mp="27yr70q9445v0" />
            the request doesn&rsquo;t run.
          </p>
        </div>
        <div className="sp-r" data-id="element-520" data-mp="22yv30r0f0efg">
          <ConstitutionalFlow data-id="element-521" data-mp="230pms1zya0hy" />
        </div>
      </div>

      <div className="quoteband" data-id="element-522" data-mp="1y8eqd94f4wu5">
        <p data-id="element-523" data-mp="1y7dcyxzxjy99">
          Wherever regulations live &mdash; agency sites, registers, guidance
          <br data-id="element-524" data-mp="1t8jyp3ctk381" />
          &mdash; they become rules your AI can act on.
        </p>
      </div>

      <div className="split" data-id="element-525" data-mp="2qp8zquty31gd">
        <div className="sp-l" data-id="element-526" data-mp="2qqa8gsnhnbux">
          <span className="clabel" data-id="element-527" data-mp="2ly91nm93adca">The receipt</span>
          <h2 data-id="element-528" data-mp="2lxh6gcjemhmj">
            You can't reconstruct a decision <span className="g" data-id="element-529" data-mp="2u6woggjodhko">you never governed.</span>
          </h2>
          <p className="lede" data-id="element-530" data-mp="2u8zlvln5qczf">
            When the auditor asks why the model said what it said, "we retrieved some relevant passages" is not an
            answer. It isn't even a defense.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-531" data-mp="339o1gks78lef">
            A receipt is an answer: <strong data-id="element-532" data-mp="387za4s6rcpv2">obligations fired, versions seated, trigger matched, timestamp signed</strong>
            . Every request ships with its proof — before anyone asks for it.
          </p>
          <p className="kicker" data-id="element-533" data-mp="3h5t4hxkyp9fl">Before anyone asks.</p>
        </div>
        <div className="sp-r" data-id="element-534" data-mp="3lxkofp9m4gwr">
          <ReceiptCard data-id="element-535" data-mp="3lyma0no98lsq" />
        </div>
      </div>

      <div className="split" data-id="element-536" data-mp="3qww6d1lptsfx">
        <div className="sp-l" data-id="element-537" data-mp="3qw49lngdtoo2">
          <span className="clabel" data-id="element-538" data-mp="3qwe33l0mydyi">No one between the steps</span>
          <h2 data-id="element-539" data-mp="3vxbffgyysds3">
            Chat forgives.
            <br data-id="element-540" data-mp="3vu5u8ctghw1n" />
            <span className="g" data-id="element-541" data-mp="4pz0z9pguefv">Agents commit.</span>
          </h2>
          <p className="lede" data-id="element-542" data-mp="4q7aqsqal3mu">
            In chat, the safety net is a human skimming on a deadline. The prompt carries only what someone thought to
            type, retrieval only fetches what was written down, and review catches the typo but misses the disclosure.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-543" data-mp="z12d6c4ek2qr">
            An agent chain removes even that net. Step three's silent omission is step seven's{' '}
            <strong data-id="element-544" data-mp="6cn9umumv8v9">committed transaction</strong>, and there was no one between the steps to catch it.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-545" data-mp="2c4jyycawcvp">
            The obligations have to ride <strong data-id="element-546" data-mp="g39nibishpbb">inside the payload</strong> — every step, a receipt at every hop.
            Agent governance that lives anywhere else arrives after the commit.
          </p>
        </div>
        <div className="sp-r" data-id="element-547" data-mp="3jrjoe26j1qas">
          <AgentChain data-id="element-548" data-mp="3jqrtktkr7wlk" />
        </div>
      </div>

      <div className="stoprow" data-id="element-549" data-mp="3jpgqyx31ouw1">
        <h2 style={{
        maxWidth: 'none'
      }} data-id="element-550" data-mp="3eti5pid0jszu">FAQs: How</h2>
      </div>

      <Faq items={faqsHow} data-id="element-551" data-mp="1uapi45upcif5" />

      <CtaBand data-id="element-552" data-mp="1uafpeai9vx5r" />
      <Ledger data-id="element-553" data-mp="1u9w72sopn6r7" />
    </>;
}